export { default as elementExists } from "./element-exists"
export { default as formSerialize } from "./form-serialize"

export const ajax = async (method, url, data = {}, contentType = 'application/json', xhttp = null) => {
    return new Promise(resolve => {
        if (!xhttp) {
            xhttp = new XMLHttpRequest();
        }
        xhttp.onreadystatechange = function () {
            if (xhttp.readyState === 4) {
                resolve(JSON.stringify({
                    status: xhttp.status,
                    response: xhttp.responseText
                }));
            }
        };

        xhttp.open(method, url, true);
        if (method === 'POST' && data) {
            xhttp.setRequestHeader('Content-type', contentType)
            xhttp.send(JSON.stringify(data));
        } else {
            xhttp.send();
        }

        return xhttp;
    });
}

export const observeAdd = async (container, callback) => {
    new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                let nodes = [].slice.call(mutation.addedNodes);
                if (nodes.length > 0) {
                    callback(nodes)
                }
            }
        }
    }).observe(container, { attributes: true, childList: true, subtree: true });
}

export const observeRemove = async (container, callback) => {
    new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                let nodes = [].slice.call(mutation.removedNodes);
                if (nodes.length > 0) {
                    callback(nodes)
                }
            }
        }
    }).observe(container, { attributes: true, childList: true, subtree: true });
}

export const cartesian = (...a) => a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())));

/*
  General purpose functions
  Use these functions to apply certain operation in your context
*/

export const insertSortedValue = (fn) => (arr, value) => [...arr.filter(n => !fn(n, value)), value, ...arr.filter(n => fn(n, value))]

export const serialize = (form) => Array.from(new FormData(form), e => e.map(encodeURIComponent).join('=')).join('&')

export const getQueryValue = (value) => (new URLSearchParams(window.location.search)).get(value)

export const asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}




